import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMyFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 8.664a5.25 5.25 0 1 1 7.73 4.629 11.4 11.4 0 0 1 5.02 2.537 5.83 5.83 0 0 1 2 4.395v.697c0 .962-.78 1.742-1.742 1.742H4.492c-.962 0-1.742-.78-1.742-1.742v-.697a5.83 5.83 0 0 1 2-4.395 11.4 11.4 0 0 1 5.02-2.537A5.25 5.25 0 0 1 7 8.664"
  }));
}
var IcMyFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMyFill));

export { IcMyFill as I };
